// Helper: group series and sort by release date ascending
export function getSortedBooks(books: any[] = []) {
  const seriesMap: Record<string, any[]> = {}
  books.forEach((book) => {
    if (book.series) {
      if (!seriesMap[book.series]) seriesMap[book.series] = []
      seriesMap[book.series].push(book)
    }
  })
  Object.values(seriesMap).forEach((seriesBooks) => {
    seriesBooks.sort(
      (a: any, b: any) => (a.seriesNumber ?? 0) - (b.seriesNumber ?? 0),
    )
  })
  const sorted: any[] = []
  const addedSeries = new Set<string>()
  const sortedByDate = [...books].sort(
    (a, b) =>
      new Date(a.releaseDate).getTime() - new Date(b.releaseDate).getTime(),
  )
  sortedByDate.forEach((book) => {
    if (book.series && !addedSeries.has(book.series)) {
      sorted.push(...seriesMap[book.series])
      addedSeries.add(book.series)
    } else if (!book.series) {
      sorted.push(book)
    }
  })
  return sorted
}

// Helper to chunk books into shelves
export const chunkBooksIntoShelves = (books: any[], booksPerShelf: number) => {
  const shelves: any[][] = []
  for (let i = 0; i < books.length; i += booksPerShelf) {
    shelves.push(books.slice(i, i + booksPerShelf))
  }
  return shelves
}
